import * as React from 'react';

interface IPromoCodeErrorProps {
    errorMessage: string;
}

class PromoCodeError extends React.Component<IPromoCodeErrorProps, any>{
    render() {
        return (
            <p className="promo-code-apply-error">
                {this.props.errorMessage}
            </p>
        );
    }
}

export default PromoCodeError;